import { h } from "@stencil/core";
/**
 * functional stencil component for a question with radio buttons
 */
export function QuestionRadio({ question, answers, setAnswers, t, baseClass }) {
    return (h("fieldset", null, h("legend", { class: "mf-proactive-case-closure__question" }, t(question.labelKey)), h("div", { class: `${baseClass}__radio-buttons-container` }, h("div", { class: `${baseClass}__radio-buttons` }, Object.entries(question.options).map(([value, option]) => (h("ux-radio-button", { key: value, type: "radio", name: question.name, value: value, checked: answers[question.name] === value, onUxRadioButtonChange: (e) => {
            setAnswers(Object.assign(Object.assign({}, answers), { [question.name]: e.detail.value }));
        } }, t(option.labelKey))))))));
}
//# sourceMappingURL=question-radio.js.map
